import React from 'react';
import { about } from '../../data/mock';

const AboutSection = () => {
  return (
    <div className="window mb-6">
      <div className="window-header">
        <span>💜 About Me</span>
      </div>
      <div className="window-body">
        <div className="flex items-start gap-3 mb-3">
          <div className="text-4xl animate-bounce">🧚‍♀️</div>
          <div className="flex-1">
            <h2 className="text-lg font-bold mb-1 pixel-text" style={{ color: '#ff1493' }}>
              Hi there! ✨
            </h2>
            <p className="leading-relaxed text-xs">
              {about.summary}
            </p>
          </div>
          <div className="text-3xl animate-pulse">💫</div>
        </div>

        <div className="bg-pink-50 p-3 border-2 border-pink-400">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-2xl">🎓</span>
            <h3 className="text-sm font-bold pixel-text" style={{ color: '#ff1493' }}>
              Education
            </h3>
          </div>
          <p className="font-bold text-xs mb-1">{about.education.degree}</p>
          <p className="text-xs mb-1">{about.education.university}</p>
          <div className="flex justify-between text-xs mt-2">
            <span className="bg-purple-200 px-2 py-0.5 rounded">First Class With Distinction</span>
            <span className="bg-pink-200 px-2 py-0.5 rounded">{about.education.graduationDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
